module.exports = __webpack_public_path__ + "img/facebook-white.53663788.svg";